import { M8PartnerClientsOnMonth } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getPaidClientsForCurrentMonth = async (): Promise<null | M8PartnerClientsOnMonth> => {
  const fetchURL = getM8PartnerURL('getPaidClientsForCurrentMonth');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
